<!-- Begin page -->
<div id="layout-wrapper" [attr.data-layout]="menuType" [attr.data-bs-theme]="theme">


  <app-dash-header></app-dash-header>

  <!-- ========== Left Sidebar Start ========== -->
  <admin-left-nav [menu]="MENU"></admin-left-nav>
  <!-- Left Sidebar End -->


  <!-- ============================================================== -->
  <!-- Start right Content here -->
  <!-- ============================================================== -->
  <div class="main-content" [ngClass]="locale==Locales.BN_BN? 'font-bn':'font-en'">

    <div id="layout-wrapper1">


      <div class="page-content bg-graphics">
        <div class="container-fluid">

          <router-outlet></router-outlet>
          <!-- End Page-content -->
        </div>
      </div>

    </div>


    <app-dash-footer></app-dash-footer>
  </div>
  <!-- end main content-->

</div>
<!-- END layout-wrapper -->

<admin-right-nav></admin-right-nav>
